import { render, staticRenderFns } from "./EmailVerificationForForgotPassword.vue?vue&type=template&id=36bc6953&"
import script from "./EmailVerificationForForgotPassword.vue?vue&type=script&lang=js&"
export * from "./EmailVerificationForForgotPassword.vue?vue&type=script&lang=js&"
import style0 from "./EmailVerificationForForgotPassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmailVerificationForForgotPassword.vue"
export default component.exports